import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './LoginForm.css';

const LoginForm = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    captchaAnswer: '',
    showPassword: false,
    keepLoggedIn: false
  });

  const [error, setError] = useState('');
  const [captcha, setCaptcha] = useState({ num1: 0, num2: 0 });

  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10);
    const num2 = Math.floor(Math.random() * 10);
    setCaptcha({ num1, num2 });
    setFormData(prev => ({ ...prev, captchaAnswer: '' }));
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');

    const correct = captcha.num1 + captcha.num2;
    if (parseInt(formData.captchaAnswer) !== correct) {
      setError('❌ Incorrect CAPTCHA answer');
      generateCaptcha();
      return;
    }

    try {
  const res = await axios.post('https://testone.onebox.pk/api/login', {
    username: formData.username,
    password: formData.password
  });

  // Make sure role is available
  const userData = res.data.user;
  if (!userData || !userData.role) {
    setError("❌ Invalid role in response");
    return;
  }

  onLogin(userData); // Pass role to App.js
} catch (err) {
  setError(err.response?.data?.message || '❌ Login failed');
}
  };

  return (
    <div className="login-wrapper">
      <form className="login-card" onSubmit={handleSubmit}>
         {/* Logo on top */}
    <center>
       <img src="/logo.png" alt="Logo" className="login-logo" />
    </center>
        <center><h2>Log in</h2></center>
        

        <div className="form-group">
          <label>Username</label>
         
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={handleChange}
            required
          />
        
        </div>

        <div className="form-group">
          <label>Password</label>
             <div className="input-wrapper">
            <input
              type={formData.showPassword ? 'text' : 'password'}
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <span
              className="show-toggle"
              onClick={() => setFormData(prev => ({ ...prev, showPassword: !prev.showPassword }))}
            >
              {formData.showPassword ? 'Hide' : 'Show'}
            </span>
          </div>
        </div>

        

        <div className="form-group">
          <label>CAPTCHA: {captcha.num1} + {captcha.num2}
<button type="button" className="refresh-btn" onClick={generateCaptcha}>↻ Refresh</button>
          </label>
            
          <input
            type="number"
            name="captchaAnswer"
            value={formData.captchaAnswer}
            onChange={handleChange}
            required
          />
        
        </div>

        {error && <div className="error-msg">{error}</div>}

        <center><button type="submit" className="login-btn">Log in</button></center>

       
      </form>
    </div>
  );
};

export default LoginForm;
